import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Ponerle nombre al miedo",
    opening: localizedGenderNode(
      [
      "Hoy no me obligo a decidir. Solo admito: tengo miedo de irme."
    ],
      [
      "Hoy no me obligo a decidir. Solo admito: tengo miedo de irme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Este miedo está aquí para protegerme, no para controlarme.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Este miedo está aquí para protegerme, no para controlarme.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué es exactamente lo que me da miedo de irme?\n[Escribe aquí]",
      "¿Qué me digo para evitar tocar este miedo?\n[Escribe aquí]",
      "¿Dónde siento este miedo en mi cuerpo ahora mismo?\n[Escribe aquí]"
    ],
      [
      "¿Qué es exactamente lo que me da miedo de irme?\n[Escribe aquí]",
      "¿Qué me digo para evitar tocar este miedo?\n[Escribe aquí]",
      "¿Dónde siento este miedo en mi cuerpo ahora mismo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo tiene una voz. Hoy la escucho sin obedecerla."
    ],
      [
      "Cierre",
      "El miedo tiene una voz. Hoy la escucho sin obedecerla."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparezcan pensamientos de irme — una respiración + la frase: “Solo estoy escuchando ahora.”",
      "Cuando aparezcan pensamientos de irme — una respiración + la frase: “Solo estoy escuchando ahora.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Lo que no está bien (sin justificar)",
    opening: localizedGenderNode(
      [
      "Hoy veo la realidad tal como es, sin suavizarla ni exagerarla."
    ],
      [
      "Hoy veo la realidad tal como es, sin suavizarla ni exagerarla."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La verdad no necesita drama.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La verdad no necesita drama.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Tres cosas que no están bien para mí en esta relación:\n[Escribe aquí]",
      "¿Cómo afecta cada una a mis emociones?\n[Escribe aquí]",
      "¿Qué gano al minimizar esto?\n[Escribe aquí]"
    ],
      [
      "Tres cosas que no están bien para mí en esta relación:\n[Escribe aquí]",
      "¿Cómo afecta cada una a mis emociones?\n[Escribe aquí]",
      "¿Qué gano al minimizar esto?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Ver la verdad no es traición. Es respeto propio."
    ],
      [
      "Cierre",
      "Ver la verdad no es traición. Es respeto propio."
    ]
    ),
    action: localizedGenderNode(
      "Hoy no justifico un comportamiento que me duele (solo lo noto).",
      "Hoy no justifico un comportamiento que me duele (solo lo noto)."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Lo que me mantiene ahí",
    opening: localizedGenderNode(
      [
      "Hoy exploro no lo que está mal — sino lo que me mantiene."
    ],
      [
      "Hoy exploro no lo que está mal — sino lo que me mantiene."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me mantiene quedándome? (miedo a estar solo/a / esperanza / culpa / hábito / dependencia)\n[Escribe aquí]",
      "¿Qué temo que ocurra si me voy?\n[Escribe aquí]",
      "¿Qué parte de mí necesita seguridad ahora mismo?\n[Escribe aquí]"
    ],
      [
      "¿Qué me mantiene quedándome? (miedo a estar solo/a / esperanza / culpa / hábito / dependencia)\n[Escribe aquí]",
      "¿Qué temo que ocurra si me voy?\n[Escribe aquí]",
      "¿Qué parte de mí necesita seguridad ahora mismo?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Si algo me sostiene — merece ser visto."
    ],
      [
      "Cierre",
      "Si algo me sostiene — merece ser visto."
    ]
    ),
    action: localizedGenderNode(
      "Nombrar una cosa que me mantiene — sin juicio.",
      "Nombrar una cosa que me mantiene — sin juicio."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Miedo a estar solo/a",
    opening: localizedGenderNode(
      [
      "Hoy toco el miedo sin huir de él."
    ],
      [
      "Hoy toco el miedo sin huir de él."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La soledad es una emoción, no una condena de por vida.”"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La soledad es una emoción, no una condena de por vida.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi imagen más aterradora de estar solo/a?\n[Escribe aquí]",
      "¿Cuándo estuve solo/a antes — y sobreviví?\n[Escribe aquí]",
      "¿Qué verdad suave existe incluso si el miedo es fuerte?\n[Escribe aquí]"
    ],
      [
      "¿Cuál es mi imagen más aterradora de estar solo/a?\n[Escribe aquí]",
      "¿Cuándo estuve solo/a antes — y sobreviví?\n[Escribe aquí]",
      "¿Qué verdad suave existe incluso si el miedo es fuerte?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El miedo nunca cuenta toda la historia."
    ],
      [
      "Cierre",
      "El miedo nunca cuenta toda la historia."
    ]
    ),
    action: localizedGenderNode(
      "5 minutos de tiempo consciente a solas (sin pantalla) — solo estar.",
      "5 minutos de tiempo consciente a solas (sin pantalla) — solo estar."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Culpa vs. responsabilidad",
    opening: localizedGenderNode(
      [
      "Hoy separo la culpa de la responsabilidad."
    ],
      [
      "Hoy separo la culpa de la responsabilidad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿De qué me siento culpable cuando pienso en irme?\n[Escribe aquí]",
      "¿Qué es realmente mi responsabilidad — y qué no lo es?\n[Escribe aquí]",
      "¿Cómo se ve la responsabilidad sin castigarme?\n[Escribe aquí]"
    ],
      [
      "¿De qué me siento culpable cuando pienso en irme?\n[Escribe aquí]",
      "¿Qué es realmente mi responsabilidad — y qué no lo es?\n[Escribe aquí]",
      "¿Cómo se ve la responsabilidad sin castigarme?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La responsabilidad no requiere sacrificio personal."
    ],
      [
      "Cierre",
      "La responsabilidad no requiere sacrificio personal."
    ]
    ),
    action: localizedGenderNode(
      "Cuando aparezca la culpa — digo: “Esto es una emoción, no un veredicto.”",
      "Cuando aparezca la culpa — digo: “Esto es una emoción, no un veredicto.”"
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Esperanza que no cambia",
    opening: localizedGenderNode(
      [
      "Hoy examino si estoy viviendo de un futuro imaginado."
    ],
      [
      "Hoy examino si estoy viviendo de un futuro imaginado."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué cambio he estado esperando durante mucho tiempo?\n[Escribe aquí]",
      "¿Qué me ha mostrado la realidad hasta ahora?\n[Escribe aquí]",
      "¿Cómo se siente mi cuerpo sosteniendo una esperanza que no se cumple?\n[Escribe aquí]"
    ],
      [
      "¿Qué cambio he estado esperando durante mucho tiempo?\n[Escribe aquí]",
      "¿Qué me ha mostrado la realidad hasta ahora?\n[Escribe aquí]",
      "¿Cómo se siente mi cuerpo sosteniendo una esperanza que no se cumple?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La esperanza que no avanza drena energía."
    ],
      [
      "Cierre",
      "La esperanza que no avanza drena energía."
    ]
    ),
    action: localizedGenderNode(
      "Hoy noto la diferencia entre lo que está pasando y lo que deseo que pase.",
      "Hoy noto la diferencia entre lo que está pasando y lo que deseo que pase."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Mi valor dentro de la relación",
    opening: localizedGenderNode(
      [
      "Hoy reviso cómo esta relación afecta mi valor personal."
    ],
      [
      "Hoy reviso cómo esta relación afecta mi valor personal."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo me siento conmigo mismo/a dentro de esta relación?\n[Escribe aquí]",
      "¿Qué pasa con mi confianza durante los conflictos?\n[Escribe aquí]",
      "¿Qué versión de mí quiere más respeto?\n[Escribe aquí]"
    ],
      [
      "¿Cómo me siento conmigo mismo/a dentro de esta relación?\n[Escribe aquí]",
      "¿Qué pasa con mi confianza durante los conflictos?\n[Escribe aquí]",
      "¿Qué versión de mí quiere más respeto?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una relación no debería encogerme."
    ],
      [
      "Cierre",
      "Una relación no debería encogerme."
    ]
    ),
    action: localizedGenderNode(
      "Una frase de autorrespeto que llevo conmigo hoy.",
      "Una frase de autorrespeto que llevo conmigo hoy."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Lo que mi cuerpo ya sabe",
    opening: localizedGenderNode(
      [
      "Mi cuerpo sabe antes que mi mente."
    ],
      [
      "Mi cuerpo sabe antes que mi mente."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo reacciona mi cuerpo cuando imagino quedarme?\n[Escribe aquí]",
      "¿Cómo reacciona mi cuerpo cuando imagino irme?\n[Escribe aquí]",
      "¿Cuál es la diferencia?\n[Escribe aquí]"
    ],
      [
      "¿Cómo reacciona mi cuerpo cuando imagino quedarme?\n[Escribe aquí]",
      "¿Cómo reacciona mi cuerpo cuando imagino irme?\n[Escribe aquí]",
      "¿Cuál es la diferencia?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El cuerpo no miente — señala."
    ],
      [
      "Cierre",
      "El cuerpo no miente — señala."
    ]
    ),
    action: localizedGenderNode(
      "Mano en el pecho/vientre + una respiración cuando aparezca la confusión.",
      "Mano en el pecho/vientre + una respiración cuando aparezca la confusión."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Miedo a equivocarme",
    opening: localizedGenderNode(
      [
      "Hoy suelto la necesidad de una decisión perfecta."
    ],
      [
      "Hoy suelto la necesidad de una decisión perfecta."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿A qué temo equivocarme?\n[Escribe aquí]",
      "¿No elegir también es una elección?\n[Escribe aquí]",
      "¿Cuál es el costo de quedarme sin elegir?\n[Escribe aquí]"
    ],
      [
      "¿A qué temo equivocarme?\n[Escribe aquí]",
      "¿No elegir también es una elección?\n[Escribe aquí]",
      "¿Cuál es el costo de quedarme sin elegir?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No hay decisión sin riesgo — pero sí hay verdad."
    ],
      [
      "Cierre",
      "No hay decisión sin riesgo — pero sí hay verdad."
    ]
    ),
    action: localizedGenderNode(
      "Hoy dejo de exigirme certeza.",
      "Hoy dejo de exigirme certeza."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Límites que faltan",
    opening: localizedGenderNode(
      [
      "Hoy veo dónde no tengo límites."
    ],
      [
      "Hoy veo dónde no tengo límites."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde me abandono repetidamente?\n[Escribe aquí]",
      "¿Qué límite me gustaría poner — pero no he puesto?\n[Escribe aquí]",
      "¿Qué miedo rodea este límite?\n[Escribe aquí]"
    ],
      [
      "¿Dónde me abandono repetidamente?\n[Escribe aquí]",
      "¿Qué límite me gustaría poner — pero no he puesto?\n[Escribe aquí]",
      "¿Qué miedo rodea este límite?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Sin límites — el miedo crece."
    ],
      [
      "Cierre",
      "Sin límites — el miedo crece."
    ]
    ),
    action: localizedGenderNode(
      "Un pequeño límite interno solo para mí (aunque no lo diga).",
      "Un pequeño límite interno solo para mí (aunque no lo diga)."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Quién soy sin la relación",
    opening: localizedGenderNode(
      [
      "Hoy recuerdo que soy más que esta relación."
    ],
      [
      "Hoy recuerdo que soy más que esta relación."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Quién era yo antes de esta relación?\n[Escribe aquí]",
      "¿Qué parte de mí se fue apagando con el tiempo?\n[Escribe aquí]",
      "¿Qué extraño de mí?\n[Escribe aquí]"
    ],
      [
      "¿Quién era yo antes de esta relación?\n[Escribe aquí]",
      "¿Qué parte de mí se fue apagando con el tiempo?\n[Escribe aquí]",
      "¿Qué extraño de mí?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "No desaparezco sin una relación."
    ],
      [
      "Cierre",
      "No desaparezco sin una relación."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que me reconecte solo conmigo.",
      "Una acción que me reconecte solo conmigo."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Una conversación interna honesta",
    opening: localizedGenderNode(
      [
      "Hoy hablo con honestidad conmigo."
    ],
      [
      "Hoy hablo con honestidad conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Si no tuviera miedo — ¿qué me admitiría?\n[Escribe aquí]",
      "¿Qué necesito más ahora mismo?\n[Escribe aquí]",
      "¿Qué ya no estoy dispuesto/a a seguir pagando?\n[Escribe aquí]"
    ],
      [
      "Si no tuviera miedo — ¿qué me admitiría?\n[Escribe aquí]",
      "¿Qué necesito más ahora mismo?\n[Escribe aquí]",
      "¿Qué ya no estoy dispuesto/a a seguir pagando?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La verdad no grita. Susurra."
    ],
      [
      "Cierre",
      "La verdad no grita. Susurra."
    ]
    ),
    action: localizedGenderNode(
      "Permito que la verdad exista sin actuar sobre ella.",
      "Permito que la verdad exista sin actuar sobre ella."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Hacia dónde voy",
    opening: localizedGenderNode(
      [
      "Hoy miro hacia adelante — no para huir, sino para orientarme."
    ],
      [
      "Hoy miro hacia adelante — no para huir, sino para orientarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo quiero sentirme en una relación futura?\n[Escribe aquí]",
      "¿Qué valor ya no estoy dispuesto/a a ceder?\n[Escribe aquí]",
      "¿Qué pequeño paso me acerca?\n[Escribe aquí]"
    ],
      [
      "¿Cómo quiero sentirme en una relación futura?\n[Escribe aquí]",
      "¿Qué valor ya no estoy dispuesto/a a ceder?\n[Escribe aquí]",
      "¿Qué pequeño paso me acerca?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La dirección comienza con la intención, no con la decisión."
    ],
      [
      "Cierre",
      "La dirección comienza con la intención, no con la decisión."
    ]
    ),
    action: localizedGenderNode(
      "Escribo un valor y lo sostengo esta semana.",
      "Escribo un valor y lo sostengo esta semana."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave (lealtad a mí)",
    opening: localizedGenderNode(
      [
      "Hoy me elijo — incluso sin una decisión final."
    ],
      [
      "Hoy me elijo — incluso sin una decisión final."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mí en este recorrido?\n[Escribe aquí]",
      "¿Qué está más claro ahora, aunque duela?\n[Escribe aquí]",
      "Una frase de regreso para días de confusión:\n[Escribe aquí]"
    ],
      [
      "¿Qué aprendí sobre mí en este recorrido?\n[Escribe aquí]",
      "¿Qué está más claro ahora, aunque duela?\n[Escribe aquí]",
      "Una frase de regreso para días de confusión:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del recorrido",
      "No tengo que saberlo todo ahora.",
      "Pero sí sé una cosa:",
      "Merezco una relación que no me asuste hasta desaparecer.",
      "Y eso es fortaleza."
    ],
      [
      "Cierre final del recorrido",
      "No tengo que saberlo todo ahora.",
      "Pero sí sé una cosa:",
      "Merezco una relación que no me asuste hasta desaparecer.",
      "Y eso es fortaleza."
    ]
    ),
    action: localizedGenderNode(
      "Una acción que me honre — aquí y ahora.",
      "Una acción que me honre — aquí y ahora."
    ),
  },
].map(buildNormalizedDay);

export const fearLeavingBadRelationshipBlueprintEs = buildNormalizedPilotBlueprint({
  id: "fear_leaving_bad_relationship_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "fear_leaving_bad_relationship",
  category: "general",
  journeyName: {
    he: "פחד לעזוב קשר לא טוב",
    en: "Fear of Leaving an Unhealthy Relationship",
    es: "Miedo a dejar una relación dañina",
  },
  days,
});

export default fearLeavingBadRelationshipBlueprintEs;
